import { render, staticRenderFns } from "./ConsultationInRoom.vue?vue&type=template&id=4a497348&scoped=true&"
import script from "./ConsultationInRoom.vue?vue&type=script&lang=js&"
export * from "./ConsultationInRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a497348",
  null
  
)

export default component.exports